<template>
  <div id="app">
    <router-view></router-view>
    <!-- 音频标签，用于播放提示音 -->
    <audio ref="tipAudio" preload="auto" style="visibility: hidden;">
      <source :src="tipAudioSrc" type="audio/wav" />
    </audio>
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},
  data() {
    return {
      tipAudioSrc: require(`@/assets/audio/tip.wav`),
      lastPlayAudioTime: 0,
      audioPermissionGranted: false, // 是否已获取播放权限
    };
  },
  mounted() {
    // 用户首次交互时获取播放权限（满足浏览器自动播放策略）
    const getAudioPermission = async () => {
      if (this.audioPermissionGranted) return;
      
      const audioEl = this.$refs.tipAudio;
      if (!audioEl) return;

      try {
        // 尝试播放然后立即暂停，以获取播放权限
        const playPromise = audioEl.play();
        if (playPromise !== undefined) {
          await playPromise;
          audioEl.pause();
          audioEl.currentTime = 0;
        }
        this.audioPermissionGranted = true;
        console.log('音频播放权限已获取');
      } catch (error) {
        console.error('获取音频播放权限失败:', error);
      }
      
      // 移除监听器
      document.removeEventListener("click", getAudioPermission);
      document.removeEventListener("touchstart", getAudioPermission);
    };

    // 监听点击和触摸事件（移动端）
    document.addEventListener("click", getAudioPermission);
    document.addEventListener("touchstart", getAudioPermission);

    // 挂载全局播放方法
    this.$root.$playAudioTip = this.playAudioTip.bind(this);
    this.$eventBus.$on("playAudioTip", this.playAudioTip);
  },
  methods: {
    playAudioTip() {
      const audioEl = this.$refs.tipAudio;
      if (!audioEl) {
        console.warn('音频元素未找到');
        return;
      }

      // 防止过于密集播放（1秒内不重复播放）
      const now = Date.now();
      if (now - this.lastPlayAudioTime < 1000) return;

      this.lastPlayAudioTime = now;

      try {
        // 重置音频到开始位置
        audioEl.currentTime = 0;
        
        // 播放音频
        const playPromise = audioEl.play();
        if (playPromise !== undefined) {
          playPromise
            .then(() => {
              console.log('音频播放成功');
              this.$store.commit("setHasInteracted", false);
            })
            .catch((error) => {
              console.log('音频播放失败');
              this.$store.commit("setHasInteracted", true);
            });
        }
      } catch (error) {
        console.error('播放音频时发生异常:', error);
        this.$store.commit("setHasInteracted", true);
      }
    },
  },
  beforeDestroy() {
    this.$eventBus.$off("playAudioTip", this.playAudioTip);
  },
};
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: absolute;
  height: 100%;
  width: 100%;
  color: var(--im-text-color);
  font-family: var(--im-font-family);
}
</style>
